import React from "react";

export default ({ title, description }) => (
  <div className="m_10_bottom">
    <strong>{title}</strong>
    {description}
  </div>
);
